import React, {Component} from 'react';

import moment from 'moment'
import config from  '../../config';
import GoogleMapComponent from './GoogleMapComponent'


import {MAP} from 'react-google-maps/lib/constants';

export default class GoogleMapWithServiceAreas extends Component {
    constructor(props) {
        super(props);
         this.state = {
            center: this.props.center ? this.props.center :   config.maps.defaultCoordinates,
            bounds: null,
            selectedLocation: this.props.selectedLocation,
            polygonsHasBeenSet: false,
            ServiceAddress:'',
            serviceAreas: [],
            serviceAreasForLocation: {}

        }

    }

    componentWillMount() {
        var self = this


    }
    componentWillReceiveProps(nextProps) {
           if (nextProps.selectedLocation.key !== this.props.selectedLocation.key){ /* when location is initially set from the parent component */
            this.setState({selectedLocation: nextProps.selectedLocation})
         }

    }
    fetchAndSetPolygons() {
        var methodData = {
            "endpoint": "/service_areas"
        };
 console.log('fetchAndSetPolygons'  );
         this.props.makeRequest({}, methodData)
            .then(function (res) {
                if (this._mapComponent && !this.state.polygonsHasBeenSet) {
                    this.setState({polygonsHasBeenSet: true})
                    var serviceAreasWithPolygons = []
                    _.forEach(res.data.data, function (serviceArea, index) {
                         var polygon = new google.maps.Polygon({
                            paths: _.map(serviceArea.Area.coordinates, function (coordinate) {
                                return {lat: coordinate[1], lng: coordinate[0]}
                            }),
                            fillColor: serviceArea.Color,
                            strokeColor: serviceArea.Color,
                            editable: this.props.editablePolygons ? this.props.editablePolygons : false,
                            draggable: this.props.draggablePolygons ? this.props.draggablePolygons : false,
                            strokeWeight: 1,
                            clickable:false,
                            strokeOpacity: 0.5,
                            zIndex: serviceArea.Priority,
                           visible:config.getEnvironmentName() == 'production' && window !== top ? true : true /* if window is  in iframe*/
                        });
                        // serviceArea.DaysOfWeekNames = _.map(serviceArea.DaysOfWeek, function (dayOfWeek) {
                        //     return config.daysOfWeekMap[dayOfWeek];
                        // });
                      //  google.maps.event.addListener(polygon, 'click', this.handleMapClick.bind(this));
                        polygon.setMap(this._mapComponent.context[MAP]);
                        serviceArea.polygonOnMap = polygon;

                        serviceAreasWithPolygons.push(serviceArea)
                    }.bind(this))
                          var objectToUpdate = {serviceAreas: serviceAreasWithPolygons};
                    console.log('this.state.selectedLocation', this.state.selectedLocation  );
                          if (this.state.selectedLocation) { /* selected location passed from the parent component */
                            objectToUpdate.serviceAreasForLocation = this.findServiceAreasForLocation(serviceAreasWithPolygons, new google.maps.LatLng(
                                typeof  this.state.selectedLocation.position.lat === "function" ?  this.state.selectedLocation.position.lat() :  this.state.selectedLocation.position.lat,
                                typeof  this.state.selectedLocation.position.lng === "function" ?  this.state.selectedLocation.position.lng() :  this.state.selectedLocation.position.lng,
                                ))
                              var serviceAreasByMarket = _.groupBy(serviceAreasWithPolygons, 'MarketName')
                             this.props.updateLocationData({ serviceAreasByMarket:serviceAreasByMarket, serviceAreasForLocation: objectToUpdate.serviceAreasForLocation, selectedLocation:this.state.selectedLocation });
                        }
                           this.setState(objectToUpdate )


                }
            }.bind(this)).catch(err => {

        });
    }

    findServiceAreasForLocation(serviceAreas, LatLng){ /* check if selected location falls into any of the orders areas */
           var selectedServiceAreas  = [];
          _.forEach(serviceAreas, function (serviceArea) {
               if (google.maps.geometry.poly.containsLocation( LatLng, serviceArea.polygonOnMap)  ) {
                  selectedServiceAreas.push(serviceArea)
            }
        }.bind(this));
         return  selectedServiceAreas
    }

    handleOnMapLoad(map) {
        if (map && !this._mapComponent) {
            this._mapComponent = map;
            this.fetchAndSetPolygons();
        }
    }
    /* Location related methods */
    handleBoundsChanged() {
        this.setState({
            bounds: this._map.getBounds(),
            center: this._map.getCenter(),
        });
    }
    handleMapClick(event) {
        console.log('in map click'   );
           if (_.size(this.findServiceAreasForLocation(this.state.serviceAreas,event.latLng))) {
            this.setState({
                serviceAreasForLocation: this.findServiceAreasForLocation(this.state.serviceAreas, event.latLng),
                selectedLocation: {
                    position: event.latLng,
                    defaultAnimation: 2,
                    key: Date.now(), // Add a key property for: http://fb.me/react-warning-keys
                },
            }, function () {
                this.props.updateLocationData({
                    serviceAreasForLocation: this.state.serviceAreasForLocation,
                     selectedLocation: this.state.selectedLocation
                });
            });
        }
    }



    handleSearchBoxMounted(searchBox) {
        console.log('inhandleSearchBoxMounted ' , this.props.handleSearchBoxMounted   );
         this._searchBox = searchBox;
        this.props.handleSearchBoxMounted && this.props.handleSearchBoxMounted(searchBox)
    }

    handlePlacesChanged(selectedPlaces = false, doNotTriggerError = false) {
        console.log('handlePlacesChanged' , selectedPlaces);
           if (selectedPlaces) {
            var  places =selectedPlaces
        } else{
           var   places = this._searchBox.getPlaces();
        }

        if (places.length > 0  ) {
            var foundServiceAreas =  this.findServiceAreasForLocation(this.state.serviceAreas,places[0].geometry.location)
            console.log('foundServiceAreas', foundServiceAreas  );

              if (_.size(foundServiceAreas)) {
                  var foundServiceAreaForSelectedLocation = _.find(foundServiceAreas, item=>{
                        return item.MarketName  ==this.props.CurrentLocation
                  })

                  if(doNotTriggerError ||  foundServiceAreaForSelectedLocation){
                      this.setState({
                          serviceAreasForLocation: foundServiceAreas,
                          center: places[0].geometry.location,
                          selectedLocation: {
                              position: places[0].geometry.location,
                              defaultAnimation: 2,
                              key: Date.now(), // Add a key property for: http://fb.me/react-warning-keys
                          },
                          ServiceAddress: places[0].formatted_address
                      }, function () {
                          this.props.updateLocationData({
                              center: places[0].geometry.location,
                              serviceAreasForLocation: this.state.serviceAreasForLocation,
                              selectedLocation: this.state.selectedLocation,
                              ServiceAddress: this.state.ServiceAddress,
                              selectedPlace:places[0]
                          });
                      });
                  } else{
                      this.props.mapAddressSelectionCallback &&  this.props.mapAddressSelectionCallback({places:places,error:true,  type:'errorAddressOutsideSelectedLocation'})
                  }
            } else{
                 this.props.mapAddressSelectionCallback &&  this.props.mapAddressSelectionCallback({places:places,error:true,  type:'errorAddressOutsideServiceAreas'})
              }
        }
    }

    render() {
       // console.log('google map this.state',  this.state  );
                return (
            <div className={'wrap-google-maps'}>

                <GoogleMapComponent
                    defaultZoom={ this.props.mapZoom ? this.props.mapZoom : config.maps.defaultZoom}
                    containerElement={
                        <div style={_.get(this.props,'customStyling.containerElement',{height: "400px", overflow: 'visible'})}/>
                    }
                    mapElement={
                        <div className={'map-elem'} style={{height: "400px"}}/>
                    }
                    onMapLoad={this.handleOnMapLoad.bind(this)}
                   // onMapClick={this.handleMapClick.bind(this)}
                    markers={this.state.selectedLocation ? [this.state.selectedLocation] : []}
                    center={this.state.center}
                    displaySearchInput={this.props.displaySearchInput}
                 //   searchInputClasses={this.props.searchInputClasses}
                    //  onMarkerRightClick={(e) => this.setState({
                    //     selectedLocation: false
                    // })}
                    onBoundsChanged={this.handleBoundsChanged.bind(this)}
                    onSearchBoxMounted={this.handleSearchBoxMounted.bind(this)}
                    bounds={this.state.bounds}
                    onPlacesChanged={this.handlePlacesChanged.bind(this)}
                />

            </div >
        );

    }
}



